import React from 'react'
import styled from '@emotion/styled'
import { StaticFooter } from 'reaxl-footer'
import '@atc/axl-atc/lib/css/axl-atc.min.css'

export default () => (
  // empty onClick handler is necessary for the OneTrust cookie modal
  // ATC uses an analytics function there, but we just need a callable function to trigger the actual onClick provided in the reaxl-footer package
  <FixAtcFooter>
    <StaticFooter id={'globalFooter'} enableOneTrustFooter={true} onClick={() => {}} />
  </FixAtcFooter>
)

const FixAtcFooter = styled.div`
  margin-top: -60px;
  color: #c2cbe5;
`
